import React from "react";

function formatRelativeTime(timestamp) {
  if (!timestamp) return "Just now";

  const now = new Date();
  const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
  const diffInSeconds = Math.floor((now - date) / 1000);

  if (diffInSeconds < 60) return "Just now";
  if (diffInSeconds < 3600) {
    const mins = Math.floor(diffInSeconds / 60);
    return `${mins} ${mins === 1 ? "minute" : "minutes"} ago`;
  }
  if (diffInSeconds < 86400) {
    const hours = Math.floor(diffInSeconds / 3600);
    return `${hours} ${hours === 1 ? "hour" : "hours"} ago`;
  }
  if (diffInSeconds < 604800) {
    const days = Math.floor(diffInSeconds / 86400);
    return `${days} ${days === 1 ? "day" : "days"} ago`;
  }

  return date.toLocaleDateString();
}

function PostCard({ post, onClick }) {
  const truncatedContent = post.content.length > 150
    ? post.content.substring(0, 150) + "..."
    : post.content;

  return (
    <button className="post-card" onClick={onClick}>
      <div className="post-card-header">
        <h3 className="post-title">{post.title}</h3>
        <span className="post-time">{formatRelativeTime(post.createdAt)}</span>
      </div>
      <p className="post-preview">{truncatedContent}</p>
      <div className="post-card-footer">
        <span className="post-author">
          {post.authorIsGuest && <span className="guest-badge">Guest</span>}
          {post.authorName}
        </span>
        <span className="post-comments">
          💬 {post.commentCount || 0} {post.commentCount === 1 ? "comment" : "comments"}
        </span>
      </div>
    </button>
  );
}

export default PostCard;
